import React from 'react';
import PropTypes from 'prop-types';

import { colors } from '../../../common/styles/style-constants';

const DoctorMale = ({ color }) => (
  <svg
    width="20"
    height="24"
    viewBox="0 0 66 83"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g fill="none" fillRule="evenodd">
      <path
        d="M51.475 20.4c.04-.698.065-1.404.064-2.13C51.51 7.893 45.427 1.86 35.83 1.216c-8.365-.56-14.667 2.762-17.538 8.287-.965 1.857-1.517 4.184-1.73 6.71-.32 1.314-.51 2.68-.51 4.096h.032c0 .01-.003.02-.004.03-.02.003-.04.004-.062.008-1.223.214-1.78 2.824-1.244 5.83.495 2.763 1.74 4.9 2.89 5.062 1.464 3.934 3.777 7.755 6.64 10.552 1.62 1.582 3.416 2.836 5.33 3.6 1.317.52 2.69.81 4.1.81 1.413 0 2.786-.29 4.1-.81 1.982-.788 3.84-2.104 5.5-3.766 2.794-2.787 5.053-6.55 6.486-10.42 1.1-.323 2.258-2.39 2.73-5.028.51-2.863.026-5.36-1.077-5.777zm-1.86 6.173c-.26 1.462-.83 2.665-1.438 3.18-.244.203-.492.3-.73.256-.134-.02-.255-.087-.363-.19-1.327 4.128-3.854 8.24-7.044 10.735-1.902 1.49-4.04 2.408-6.303 2.408-2.212 0-4.307-.877-6.178-2.31-3.25-2.487-5.826-6.65-7.17-10.834-.11.1-.23.168-.362.187-.276.05-.567-.087-.844-.366-.564-.562-1.08-1.7-1.323-3.068-.015-.09-.024-.177-.037-.266.012-.956.053-1.884.12-2.8.12-.353.278-.628.482-.774.086-.063.18-.103.28-.12.227-.04.465.047.698.234h.002l.003-.056c.08-.78 1.12-7.593 7.678-6.984 0 0 5.75 2.114 10.98.246.562-.013 1.11-.017 1.618.003 2.168.08 3.65 1.204 5.205 1.927-.062-.713-.61-1.446-.58-1.927.247.07.474.177.69.294 1.12 1.19 2.2 3.19 3.063 6.456l.004.042.008-.006v.004l.015-.015c.226-.177.457-.26.68-.22.058.01.11.027.163.052.715.335 1.022 2.006.682 3.91z"
        fill={color}
      />
      <path
        d="M55.816 46.82c-1.257-.295-3.934-.502-3.934-.502s-4.364-.36-4.943-.542c-.237 1.97-5.966 8.447-9.72 12.51l-1.627-6.27c1.227-.722 1.49-2.314 1.49-3.638h-6.168c0 1.313.264 2.89 1.462 3.617l-1.6 6.29c-3.755-4.064-9.48-10.54-9.718-12.51-1.032.323-4.158.493-4.158.493s-3.76.325-4.72.55c-.806.188-9.962 1.56-9.962 11.226 0 .228-.877 21.434-.877 21.434-.068 1.653 1.214 2.994 2.874 2.994h58.138c1.658 0 2.946-1.347 2.88-2.993l-.88-21.436c0-9.666-6.958-10.855-8.538-11.224z"
        fill={color}
      />
      <path
        d="M50.586 63.503v2.667h2.77v-2.667H56v-2.76h-2.643V58.09h-2.77v2.653h-2.643v2.76h2.642z"
        fill="#FFF"
      />
    </g>
  </svg>
);

DoctorMale.defaultProps = {
  color: colors.blue,
};

DoctorMale.propTypes = {
  color: PropTypes.string,
};

export default DoctorMale;
